import {
  JOB_ACTIONS,
  JOB_STATUSES,
} from 'containers/App/Header/JobManagement/constants';
import {
  LOADED_STATES,
  PAGE_URL,
  RUNNING_DISCOVERY_STATUSES,
  UNLOADED_STATES,
} from './constants';

export const getElapsedTime = (discoverySecondsElapsed) => {
  if (!discoverySecondsElapsed || discoverySecondsElapsed <= 0) {
    return '00:00';
  }
  const hours = Math.floor(discoverySecondsElapsed / 3600);
  const minutes =
    `0${Math.floor(discoverySecondsElapsed / 60) - hours * 60}`.slice(-2);
  const seconds = `0${discoverySecondsElapsed % 60}`.slice(-2);
  if (hours >= 1) {
    return `${hours}:${minutes}:${seconds}`;
  }
  return `${minutes}:${seconds}`;
};

export function isSnapshotLoaded(state) {
  return LOADED_STATES.includes(state);
}

export function isSnapshotUnloaded(state) {
  return UNLOADED_STATES.includes(state);
}

export function isCurrentSnapshotRunning(snapshot) {
  return (
    snapshot &&
    (snapshot.get('state') === 'discovering' ||
      RUNNING_DISCOVERY_STATUSES.indexOf(snapshot.get('status')) > -1)
  );
}

export function isSnapshotRunning(snapshots) {
  return snapshots?.find((snapshot) => isCurrentSnapshotRunning(snapshot));
}
// biome-ignore lint/complexity/noExcessiveCognitiveComplexity: legacy code
export function updateSnapshotState(jobAction, jobStatus, currentState) {
  if (
    ![JOB_STATUSES.running, JOB_STATUSES.done, JOB_STATUSES.error].includes(
      jobStatus,
    )
  ) {
    return currentState;
  }
  switch (jobAction) {
    case JOB_ACTIONS.snapshotLoad:
    case JOB_ACTIONS.topologyCalculation:
      return [JOB_STATUSES.running, JOB_STATUSES.stopping].includes(jobStatus)
        ? 'loading'
        : jobStatus === JOB_STATUSES.error
          ? 'unloaded'
          : 'loaded';
    case JOB_ACTIONS.snapshotUnload:
      return jobStatus === JOB_STATUSES.running
        ? 'unloading'
        : jobStatus === JOB_STATUSES.error
          ? 'loaded'
          : 'unloaded';
    case JOB_ACTIONS.discovery: {
      return [JOB_STATUSES.running, JOB_STATUSES.stopping].includes(jobStatus)
        ? 'discovering'
        : jobStatus === JOB_STATUSES.error
          ? 'unloaded'
          : 'loaded';
    }
    default:
      return currentState;
  }
}

export function userInSnapshotsManagement() {
  const { pathname } = window.location;
  return (
    pathname.startsWith('/snapshot-management') &&
    pathname !== '/snapshot-management/tasks' &&
    pathname !== '/snapshot-management/errors'
  );
}

export const isSnapshotManagementPage = (snapshotId) =>
  window.location.pathname.startsWith(`${PAGE_URL}/${snapshotId}`);
